<template>
  <div class="record-comment">
    <div class="comment-container">
      <record-comment-skeleton v-if="globalLoading"></record-comment-skeleton>
      <template v-else-if="data && data.length > 0">
        <record-comment-list :content="data" @retry="handleRetry"></record-comment-list>
        <div ref="bottomSpaceHolder" style="height: 0px; width: 100%;"></div>
      </template>
      <div v-else class="empty-log">
        <div>
          <div class="empty-pagex">
            <x-svg-icon name="empty-page"></x-svg-icon>
          </div>
          <span class="empty-text">
            暂无评论
          </span>
        </div>
      </div>
    </div>
    <record-comment-input
      ref="commentInput"
      class="comment-input"
      @goBottom="goBottom"
      @clickAtPeople="clickAtPeople"
      @comment="doComment"
    ></record-comment-input>
  </div>
</template>

<script>
import RecordCommentInput from './record-comment-input/record-comment-input.vue'
import RecordCommentList from './record-comment-list/record-comment-list.vue'
import RecordCommentSkeleton from './record-comment-skeleton/record-comment-skeleton'
import apis from '@/api'
import UUID from '@/util/uuid.util'
import DateUtil from '@/util/date.util'
import { mapMutations } from 'vuex'
import { SET_COMP_PAYLOAD, CLEAR_COMPROUTER_STORE } from '@/store/comp-router.store.js'
export default {
  name: 'RecordComment',
  components: {
    RecordCommentInput,
    RecordCommentList,
    RecordCommentSkeleton
  },
  inject: ['addKeepAlive', 'removeKeepAlive'],
  data() {
    return {
      globalLoading: false,
      data: [],
      documentId: '',
      formId: '',
      sendingIds: [],
      keepAliveComps: {}
    }
  },
  created() {
    this.documentId = this.$route.query.documentId
    this.formId = this.$route.query.formId
  },
  mounted() {
    this.queryComments()
    // console.log(this.$refs.commentInput.$refs.commentInput, '孙子组件')
  },
  activated() {
    this.removeKeepAlive(this.$options.name)
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    clickAtPeople() {
      this.compRouterPush('FormPeopleSelect', {
        key: 'person-select',
        widgetConfig: {
          chooseType: 'SINGLE'
        },
        value: [],
        callback: (selectedArray) => {
          console.log(selectedArray)
        }
      })
    },
    compRouterPush(compName, compPayload) {
      compPayload && this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$options.name)
      this.$nextTick(() => {
        if (typeof compName === 'object') {
          // 兼容关联表单
          this.$router.push(compName)
        } else {
          this.$router.push({
            name: compName,
            params: {
              id: 'all'
            },
            query: {
              appId: this.$route.query.appId,
              key: compPayload.key,
              formId: this.$route.query.formId,
              documentId: this.$route.query.documentId,
              menuId: this.$route.query.menuId,
              inTable: compPayload.inTable,
              tableUUID: compPayload.tableUUID
            }
          })
        }
      })
    },
    preQueryCommentsParams() {
      return {
        ...apis.APP_PAGE.QUERY_RECORD_COMMENT,
        params: {
          documentId: this.documentId,
          formId: this.formId,
          pageQuery: {
            page: 1,
            pageSize: 9999
          }
        }
      }
    },
    queryComments() {
      // console.log(this.preQueryCommentsParams())
      this.$refs.commentInput.$refs.commentInput.clearContent()
      this.globalLoading = true
      this.$request(this.preQueryCommentsParams())
        .asyncThen(
          (resp) => {
            console.log(resp)
            this.globalLoading = false
            this.data = resp.table
            this.goBottom()
          },
          (err) => {
            this.globalLoading = false
            console.error(err)
          }
        )
        .asyncErrorCatch(() => {
          this.globalLoading = false
        })
    },
    queryCommentsSilently() {
      this.$request(this.preQueryCommentsParams())
        .asyncThen(
          (resp) => {
            console.log(resp)
            const tmp = this.data.filter((item) => !item.id && item.sendingId && !item.sending)
            this.data = resp.table.concat(tmp)
            this.goBottom()
          },
          () => {
            //
          }
        )
        .asyncErrorCatch(() => {
          //
        })
    },
    doComment(content, mentionedUsers, attachmentsId, user) {
      const sendingId = this.preSend(content, mentionedUsers, attachmentsId, user)
      this.comment(content, mentionedUsers, attachmentsId, sendingId)
    },
    comment(content, mentionedUsers, attachmentsId, sendingId) {
      const request = {
        ...apis.APP_PAGE.COMMENT_RECORD,
        params: {
          content,
          formId: this.formId,
          documentId: this.documentId,
          attachmentsId,
          mentionedUsers
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.afterSend(sendingId, true)
            this.queryCommentsSilently()
          },
          () => {
            this.afterSend(sendingId)
          }
        )
        .asyncErrorCatch(() => {
          this.afterSend(sendingId)
        })
    },
    preSend(content, mentionedUsers, attachmentsId, user) {
      const sendingId = UUID.guid()
      this.sendingIds.push(sendingId)
      this.data.push({
        content,
        formId: this.formId,
        documentId: this.documentId,
        attachmentsId,
        mentionedUsers,
        sending: true,
        sendingId,
        creationDate: DateUtil.getDateValue(new Date()),
        commenter: {
          ...user,
          headPortrait: user.avatarUrl
        }
      })
      this.goBottom()
      return sendingId
    },
    afterSend(sendingId, dropAfterSuccess = false) {
      const current = this.data.find((item) => item.sendingId === sendingId) || {}
      current.sending = false
      if (dropAfterSuccess) {
        current.error = undefined
        current.sendingId = undefined
      } else {
        current.error = true
      }
    },
    handleRetry(item) {
      item.sending = true
      this.comment(item.content, item.mentionedUsers, item.attachmentsId, item.sendingId)
    },
    goBottom() {
      console.log('滑动到底')
      this.$nextTick(() => {
        this.$refs.bottomSpaceHolder &&
          this.$refs.bottomSpaceHolder.scrollIntoView({
            behavior: 'smooth'
          })
      })
    },
    handleStrech() {
      this.goBottom()
    }
  }
}
</script>

<style lang="scss">
.record-comment {
  height: 100%;
  width: 100%;
  flex-direction: column;
  display: flex;

  .comment-container {
    /*display: flex;*/
    width: 100%;
    background-color: $--app-body-bgColor;
    position: relative;
    overflow: hidden auto;
    flex: 1 0;
    .empty-log {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $--app-notice-color;
      text-align: center;
      .svg-icon {
        width: 84px!important;
        height: 84px!important;
        margin-bottom: 7px;
        color: $--app-notice-color;
      }
    }
  }
  .comment-input {
    flex: 0 0;
  }
}
</style>
